// RFC 7807 problem+json shape, plus PH10 extensions.
// Backend's @ControllerAdvice translates PhException subclasses into this shape.
export interface ProblemDetail {
  type: string;
  title: string;
  status: number;
  detail?: string;
  instance?: string;
  /** Field-level validation errors (status 422). Map of field path → message. */
  errors?: Record<string, string>;
  /** Correlation ID set by the backend's request filter; surface in toasts as "Reference: …". */
  traceId?: string;
}

export class ApiError extends Error {
  readonly status: number;
  readonly problem: ProblemDetail;
  constructor(problem: ProblemDetail) {
    super(problem.detail ?? problem.title);
    this.name = 'ApiError';
    this.status = problem.status;
    this.problem = problem;
  }
}
